import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class WebsocketService {
  readonly URL_API = '/websocket';
  constructor(private http: HttpClient) {}

  // sendSocket
  sendSocket(url: string, uuid: any) {
    console.log('sendSokect', url, ' and ', uuid);
    return this.http.post('https://' + url + this.URL_API + '/onConnection', uuid);
  }
}
